<template>
  <v-dialog v-model="dialog" max-width="800px" :fullscreen="isMobile">
    <emp-edit :emp="emp" v-if="isEdit"></emp-edit>
    <emp-fp-details :emp="emp" v-else-if="isEnroll"></emp-fp-details>
    <emp-details :emp="emp" v-else></emp-details>
  </v-dialog>
</template>

<script>
import EmpDetails from './EmpDetails'
import EmpEdit from './EmpEdit'
import EmpFpDetails from './EmpFpDetails'
export default {
  components: {
    EmpEdit,
    EmpDetails,
    EmpFpDetails
  },
  data() {
    return {
      dialog: true,
      emp: null
    }
  },
  created() {
    this.setEmp()
  },
  methods: {
    setEmp() {
      if (!this.emps) return
      this.dialog = true
      this.emp = this.emps.find(emp => emp._id === this.empId)
    },
    onClose() {
      this.dialog = false
      this.$router.push((this.isEdit || this.isEnroll) && this.emp ? '../' : './')
    },
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    emps() {
      return this.$store.getters.emps
    },
    empId() {
      return this.$route.params.id
    },
    isEdit() {
      return this.$route.name === 'edit'
    },
    isEnroll() {
      return this.$route.name === 'enroll'
    }
  },
  watch: {
    '$route.params.id': function () {
      this.setEmp()
    },
    dialog(val) {
      val || this.onClose()
    },
    emps() {
      this.setEmp()
    }
  }
}
</script>

<style></style>